import { ProductHeading } from "@product-details/components/ProductHeading";
import { useConsumablesProductDetailsContext } from "@product-details/providers/ConsumablesProductDetailsProvider";

import { useConsumablesProductData } from "../../hooks/useConsumablesProductData";

export const ConsumablesProductHeading = () => {
  const { consumablesProductDetailsComponentData, currentMatrixItem } = useConsumablesProductDetailsContext();

  const { subtitle } = useConsumablesProductData();

  const productName = currentMatrixItem.product.name ?? "";

  return (
    <ProductHeading
      description={subtitle}
      productName={productName}
      badgeText={
        consumablesProductDetailsComponentData.overwriteBadgeText ?? consumablesProductDetailsComponentData.badgeText
      }
      hasBadge={
        !!consumablesProductDetailsComponentData.overwriteBadgeText || consumablesProductDetailsComponentData.hasBadge
      }
    />
  );
};
